import { useRef, useState } from 'react'
import LoadingBar from 'react-top-loading-bar';
import { LogInSchoolID } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { ApiCmnHeadersPostCall } from '../../../JS/Connector';
import MultiErrorPopup from '../../../Components/MultiErrorPopup';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';

export default function ImportHelpdeskItems() {
    const fileRef = useRef();
    const refForWithUser = useRef();
    const [NewAlerts, setNewAlerts] = useState(false);
    const [fileName, setFileName] = useState({
        error: '',
        document: ''
    });
    const navigate = useNavigate();
    const [showErrorPopup, setShowErrorPopup] = useState({
        modal: false,
        btn: false
    });
    const [csvError, setCsvError] = useState("");
    function ShowFileName() {
        const fileRefvar = fileRef.current;
        const files = fileRefvar.files[0];
        if (!files) return;
        const selectedfilename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...fileName, document: "", error: validationMsg });
            fileRefvar.value = "";
            return;
        }
        setFileName({ ...fileName, document: selectedfilename, error: "" });
    }
    async function ImportCSV(e, flag) {
        setCsvError('');
        setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });
        var temp = 0;
        e.preventDefault();

        const fileInput = fileRef.current;
        const files = fileInput.files[0];
        if (!files) {
            setFileName({ ...fileName, error: "First, import the CSV file.", document: "" });
            fileInput.value = "";
            return;
        }
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...fileName, error: validationMsg, document: "" });
            fileInput.value = "";
            return;
        }

        temp++;

        const selectedfilename = files.name;
        setFileName({ ...fileName, error: "", document: selectedfilename });

        var formdata = new FormData();
        formdata.append("file", files);
        formdata.append("schoolId", LogInSchoolID);

        if (temp == 1) {
            const loaderRef = refForWithUser.current;
            if (loaderRef) { loaderRef.continuousStart() }

            try {
                const response = await ApiCmnHeadersPostCall(`/helpdesk/import`, formdata, false, true);
                const responseRs = JSON.parse(response);
                if (responseRs.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={'If there was any mismatched or invalid data, or any mismatched headers in your CSV, those entries would have been skipped.'} />);
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />);
                        navigate('/helpdesk')
                    }, 4000);

                } else {
                    setCsvError(responseRs);
                    fileInput.value = "";
                    setShowErrorPopup({ ...showErrorPopup, modal: true, btn: true });
                    setFileName({ ...fileName, error: "", document: "" });
                }
            } catch (error) {
                log.error('error', error);
                fileInput.value = "";
                setFileName({ ...fileName, error: "", document: "" });
                setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });
            } finally {
                if (loaderRef) {
                    loaderRef.complete();
                    fileInput.value = "";
                    setFileName({ ...fileName, error: "", document: "" });
                }
            }
        }
    }
    return (
        <div>
            {NewAlerts}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Import Help Desk Items</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    The system matches issues with existing Help Desk categories. If a match exists, it will be used without creating duplicates. New categories or issues will not be created during CSV import. Ensure entries align with existing Help Desk types.
                </p>

                <div className="row pt-1">
                    <div className="col-12">
                        <label className="pb-4 ps-2 text-justify" style={{ fontSize: "13px" }}>
                            <a onClick={() => downloadSampleCSV('helpDeskItems', 'Helpdesk_Items')}
                                style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                                CLICK HERE
                            </a> {" "}
                            to download the template CSV file for Help Desk items. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                        </label>
                        <div className='d-flex gap-3 align-items-center'>
                            <form onSubmit={(e) => ImportCSV(e, 1)}>
                                <input type="file" ref={fileRef} name="upload_file" id="UploadFileId" accept='.csv' onChange={ShowFileName} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="UploadFileId"> Import Help Desk Items

                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {fileName.document != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                            </form>
                            {showErrorPopup.btn &&
                                <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                    View Errors
                                </label>
                            }
                        </div>
                        {fileName.document && <div className=" ps-2 my-2" style={{ fontWeight: "600", color: 'green' }}>{fileName.document}</div>}
                        {fileName.error?.trim() != "" && <label className="redText">{fileName.error}</label>}
                        <div className='position-relative'>  <LoadingBar style={{ borderRadius: "6px" }} color='var(--primary-color)' ref={refForWithUser} containerClassName='progressbarClass' /></div>
                    </div>
                </div>
            </div>
            <MultiErrorPopup isErrorShow={showErrorPopup.modal} setErrorShow={() => setShowErrorPopup({ ...showErrorPopup, modal: !showErrorPopup.modal })} errorMsgs={csvError} />
        </div>
    )
}
